import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class ProductServiceService {

  constructor(
    private http: HttpClient
  ) { }
  
  saveProductService(id: any, payload: any) {
    if (id) {
      return this.http.put(urls.API_URL +  urls.QUICKBOOK + '/services' + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL +  urls.QUICKBOOK  +  '/services', payload)
      .pipe(catchError(errorHandl));
  }

  getProductServices(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.QUICKBOOK + "/" + urls.SERVICES, { params })
      .pipe(catchError(errorHandl));
  }

  getProductServiceById(id: any) {
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/services' + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getAccount(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams || {} });
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/'+ urls.ACCOUNTS, { params })
      .pipe(catchError(errorHandl));
  }

  syncProductService(compamyId: any, serviceId: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.QUICKBOOK + '/' + urls.SERVICES + `/${serviceId}/${urls.SYNC}`, { params })
      .pipe(catchError(errorHandl));
  }
}
